module.exports = __webpack_public_path__ + "static/img/legend_xa_spanish_dark_vertical.47e7f63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xa_spanish_dark_vertical.png
// module id = UJzI
// module chunks = 94